import styles from './expired-license.module.scss';
import { booleanHeader, Box, Container, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, TableProductsFilterProps, textHeader } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { useTranslation } from 'react-i18next';
import FullTable from '../../full-table/full-table';
import { addYears } from 'date-fns';
import { ValueFormatterParams } from 'ag-grid-community';
import { useContext, useState } from 'react';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useGetRequestNewHook } from '../../requestUtils';
import { RelationProductGroupContext } from '../../relation-product-context/relation-product-context';

/* eslint-disable-next-line */
export interface LicenseAccessProps { }

export function LicenseAccess(props: LicenseAccessProps) {
  const { t } = useTranslation();
  const relationProducts = useContext(RelationProductGroupContext);
  const [selectedProductGroupIds, setSelectedProductGroupIds] = useState<string[]>([]);
  const onSelectProductIds = (ids: string[]) => { setSelectedProductGroupIds(ids) };

  const productsFilter: TableProductsFilterProps = {
    products: relationProducts,
    selectedProductGroupIds: selectedProductGroupIds,
    setSelectedProductGroupIds: onSelectProductIds
  }
  let url = 'accounts/usersWithLicenseAccess';
  if (selectedProductGroupIds.length > 0) {
    url = url.concat(`?values=${selectedProductGroupIds.join("&values=")}`);
  }
  const { data, getData } = useGetRequestNewHook(url, []);
  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.licenseAccess")} />
            <WebkuaTable
              data={data}
              productsFilter={productsFilter}
              headers={CreateHeaders([
                textHeader('firstName', t("standard.firstName"), HeaderSizeEnum.LARGE),
                textHeader('lastName', t("standard.lastName"), HeaderSizeEnum.LARGE),
                textHeader('email', t("standard.email"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("productNames", t("standard.products"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
                textHeader("roleName", t("standard.role"), HeaderSizeEnum.MEDIUM),
                booleanHeader("isAcademic", t("standard.academic")),
              ])}
              onRefresh={getData}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default LicenseAccess;